import { CircleIcon, ShieldCheckIcon, Typography } from "@codat/orchard-ui";
import { ApiLink } from "api/shared";

import TextLink from "components/TextLink";

import styles from "./DataSecurity.module.css";

type DataSecurityProps = ApiLink;

const DataSecurityLink: React.FC<DataSecurityProps> = ({ link }) => {
  if (link?.href) {
    return (
      <TextLink
        className={styles.link}
        href={link.href}
        target="_blank"
        data-testid="data-security-link"
        analyticsName="Data security"
      >
        {link.text ?? link.href}
      </TextLink>
    );
  }

  if (link?.text) {
    return (
      <Typography
        className={styles.link}
        variant="p"
        as="p"
        data-testid="data-security-text"
      >
        {link.text}
      </Typography>
    );
  }

  return null;
};

export const DataSecurity: React.FC<DataSecurityProps> = ({
  description,
  link,
  ...props
}) => {
  return (
    <section className={styles.container} {...props}>
      <CircleIcon className={styles.icon} icon={ShieldCheckIcon} />
      {description && (
        <Typography
          variant="h3"
          as="h3"
          className={styles.text}
          data-testid="data-security-description"
        >
          {description}
        </Typography>
      )}
      <DataSecurityLink link={link} />
    </section>
  );
};
